/**
 * Path prefixes for routes that require authentication (PrivateRoute or equivalent).
 * Used by the API layer to decide whether to redirect to login on 401.
 * Keep in sync with PrivateRoute usage in App.js.
 */
const PRIVATE_PATH_PREFIXES = [
  '/registration',
  '/checkin',
  '/servicio/generaciones',
  '/admin',
  '/tablero',
  '/intranet',
  '/utils/whatsapp-test',
];

export function isPrivatePath(pathname) {
  return PRIVATE_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
}
